import styled from 'styled-components';
import { fromLarge } from 'styleUtils/mediaQueries';
import { gridDisplay, gridTemplateColumns, gridTemplateRows } from 'styleUtils/grid';
import { onIe } from 'styleUtils/browserSupport';

const imageHeight = '110px';
const imageWidth = '160px';
const gridGap = '5px';
export const Wrapper = styled.div`
    ${gridDisplay()}
    ${gridTemplateColumns('1fr 1fr 1fr')}
    ${gridTemplateRows('auto')}

    grid-gap: ${gridGap};
    height: max-content;

    ${fromLarge`
        ${gridTemplateColumns(`${imageWidth} ${imageWidth} ${imageWidth}`)}
        ${gridTemplateRows(`${imageHeight} ${imageHeight} ${imageHeight}`)}
    `};

    img,
    video {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    // Fix grid for IE
    ${onIe`
        & > *:nth-child(1) {
            -ms-grid-row: 1;
            -ms-grid-column: 1;
        }
        & > *:nth-child(2) {
            -ms-grid-row: 1;
            -ms-grid-column: 2;
            margin-left: ${gridGap};
        }
        & > *:nth-child(3) {
            -ms-grid-row: 1;
            -ms-grid-column: 3;
            margin-left: ${gridGap};
        }
        & > *:nth-child(4) {
            -ms-grid-row: 2;
            -ms-grid-column: 1;
        }
        & > *:nth-child(5) {
            -ms-grid-row: 2;
            -ms-grid-column: 2;
            margin-top: ${gridGap};
            margin-left: ${gridGap};
        }
        & > *:nth-child(6) {
            -ms-grid-row: 2;
            -ms-grid-column: 3;
            margin-top: ${gridGap};
            margin-left: ${gridGap};
        }
        & > *:nth-child(7) {
            -ms-grid-row: 3;
            -ms-grid-column: 1;
            margin-top: ${gridGap};
        }
        & > *:nth-child(8) {
            -ms-grid-row: 3;
            -ms-grid-column: 2;
            margin-top: ${gridGap};
            margin-left: ${gridGap};
        }
        & > *:nth-child(9) {
            -ms-grid-row: 3;
            -ms-grid-column: 3;
            margin-top: ${gridGap};
            margin-left: ${gridGap};
        }
    `}
`;
